import React from "react";
import {useNavigate} from "react-router-dom";
import styles from "../styles/ErrorNotification.module.css";

function ErrorNotification({showError, location}) {
    const navigate = useNavigate();

    // Public pages that should work on mobile devices
    const publicPages = [
        "/plans",
        "/register",
        "/laanc",
        "/contactus",
        "/privacy-policy",
        "/terms-conditions",
        "/resources",
        "/forgot-password",
        "/reset-password",
        "/signup",
        "/upgrade",
        "/dashboard" // Organization dashboard
    ];

    const publicPaths = [
        "/verify",
        "/request-otp",
        "/unsubscribe",
        "/invitations/accept",
        "/help", // All help & support pages (getting-started, guides, faqs)
        "/organization/settings",
        "/organization/team",
        "/activities", // Organization activities page
        "/missionlog", // Mission/Operation logs page
        "/operations/templates", // Operation templates page
        "/fleet/drones", // Fleet management - Drones
        "/fleet/batteries", // Fleet management - Batteries
        "/fleet/payloads", // Fleet management - Payloads & Sensors
        "/fleet/maintenance", // Fleet maintenance schedule
        "/compliance/dashboard", // Compliance dashboard
        "/compliance/checklists", // Checklists page
        "/analytics" // All analytics pages
    ];

    const shouldHideError = publicPages.some(page => location.pathname === page) ||
                           publicPaths.some(path => location.pathname.includes(path));

    if (!showError || shouldHideError) {
        return null;
    }

    const handleNavigate = () => {
        navigate("/plans");
    };

    return (
        <>
            <div className={styles.overlay}></div>
            <div className={styles.error_message_wrapper}>
                <div className={styles.error_message}>
                    <div className={styles.topic}>
                        Error Notification (Screen Size Error)
                    </div>
                    <div className={styles.message}>
                        "We're sorry, but this application requires a minimum screen size
                        to function properly. Please resize your window to a larger size
                        for the best user experience."
                    </div>
                    <button className={styles.navigateButton} onClick={handleNavigate}>
                        Go to Plans
                    </button>
                </div>
            </div>
        </>
    );
}

export default ErrorNotification;